import { createFormDataRequest } from "@/helpers/FormHelpers";
import { IFilters, IPaginateResponse } from "@/interfaces/Fetch";
import Note, { NoteForm } from "@/interfaces/Note";
import api from "../api";

export const companyNotesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCompanyNotes: build.query<IPaginateResponse<Note>, [string, IFilters]>({
      query: ([id, data]) => {
        const params = createFormDataRequest(data);
        return {
          url: `/companies/${id}/notes`,
          params,
        };
      },
      providesTags: (result, _error, _arg) =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: "CompanyNotes" as const,
                id,
              })),
              { type: "CompanyNotes", id: "LIST" },
            ]
          : [],
    }),
    storeCompanyNote: build.mutation<Note, [string, NoteForm]>({
      query: ([id, body]) => ({
        url: `/companies/${id}/notes`,
        method: "POST",
        body,
      }),
      invalidatesTags: (_result, _error, [companyId]) => [
        { type: "CompanyNotes", companyId },
        { type: "Companies", id: companyId },
      ],
    }),
    updateCompanyNote: build.mutation<Note, [string, string, NoteForm]>({
      query: ([companyId, noteId, body]) => ({
        url: `/companies/${companyId}/notes/${noteId}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (_result, _error, [companyId]) => [
        { type: "CompanyNotes", companyId },
        { type: "Companies", id: companyId },
      ],
    }),
    deleteCompanyNote: build.mutation<void, [string, string]>({
      query: ([companyId, noteId]) => ({
        url: `/companies/${companyId}/notes/${noteId}`,
        method: "DELETE",
      }),
      invalidatesTags: (_result, _error, [companyId]) => [
        { type: "CompanyNotes", companyId, id: "LIST" },
      ],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetCompanyNotesQuery,
  useStoreCompanyNoteMutation,
  useUpdateCompanyNoteMutation,
  useDeleteCompanyNoteMutation,
} = companyNotesApi;
